import {
    Component,
    EventEmitter,
    Input,
    OnDestroy,
    Output,
} from '@angular/core';

import { Column, Sort, SortOrder } from '../experimental.grid';
import { GridSortClickEvent } from '../reusable-grid.model';

@Component({
    selector: 'reusable-grid-sort',
    template: `<button
        class="cmps-button--no-bg grid-sort-btn"
        cmpsButton
        (click)="sortClick.emit({ column, gridSortDef })"
    >
        <cmps-icon
            [svgIcon]="
                gridSortDef.order === _SortOrder.ASC
                    ? 'chevron-up'
                    : 'chevron-down'
            "
            *ngIf="isSorting"
        ></cmps-icon>
        <cmps-icon
            svgIcon="unfold-more-horizontal"
            *ngIf="!isSorting"
        ></cmps-icon>
        <ng-content></ng-content>
    </button>`,
    host: {
        class: 'reusable-grid-sort',
    },
})
export class ReusableGridSortComponent implements OnDestroy {
    @Input() gridSortDef: Sort;
    @Input() column: Column;
    @Input() isSorting: boolean;
    @Output() sortClick: EventEmitter<GridSortClickEvent>;

    /** @private */ _SortOrder = SortOrder;

    constructor() {
        this.sortClick = new EventEmitter<GridSortClickEvent>();
        this.gridSortDef = { columnId: '', order: this._SortOrder.ASC };
        this.column = { id: '' };
        this.isSorting = false;
    }

    ngOnDestroy(): void {
        this.sortClick.complete();
    }
}
